import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { UserService } from 'src/app/shared/user.service';

@Component({
  selector: 'app-email-confirmation',
  templateUrl: './email-confirmation.component.html',
  styleUrls: ['./email-confirmation.component.css']
})
export class EmailConfirmationComponent implements OnInit {
  public code:string = null;
  public message:string = '';
  public success:boolean = false;
  public apicallcompleted:boolean = false; 
  constructor(private route: ActivatedRoute,public userService: UserService) { 
    this.code = this.route.snapshot.queryParamMap.get('code');
  }

  ngOnInit(): void {
    let loaderElement = document.getElementById('loader');
    if (loaderElement) {
        loaderElement.style.display='block';
    }

    this.userService.tokenConfirmation(this.code).then((res)=>{
      this.message = res;
      this.success = true;
    }).catch((r)=>{
      this.success = false;
    }).finally(()=>{
      this.apicallcompleted = true;
      if (loaderElement) {
          loaderElement.style.display='none';
      }
    });
}


}
